import { useSelectedAgentModel } from "@ext/agent/components/hooks/useSelectedAgentModel";
import { setSessionSelectedModel, useActiveSessionId } from "@ext/agent/components/store/AgentStore";
import { formatReasoningEffort } from "@ext/agent/components/utils/formatReasoningEffort";
import { DropdownMenuSeparator } from "@ui-kit/Dropdown";
import { Slider, SliderRange, SliderThumb, SliderTrack } from "@ui-kit/Slider";
import { TextOverflowTooltip } from "@ui-kit/Tooltip";
import type { KeyboardEvent } from "react";

// The dropdown menu handles arrow keys and typeahead itself, which would steal focus from the thumb.
const keepKeysInsideSlider = (event: KeyboardEvent) => event.stopPropagation();

const ChatReasoningEffortSlider = () => {
	const activeSessionId = useActiveSessionId();
	const selection = useSelectedAgentModel();
	const reasoningPick = selection?.model.reasoningPick;
	if (!selection?.reasoningEffort || !reasoningPick?.available) return null;

	const { model, reasoningEffort } = selection;
	const { values } = reasoningPick;
	const handleValueChange = ([index]: number[]) => {
		const effort = values[index];
		if (activeSessionId && effort)
			setSessionSelectedModel(activeSessionId, { type: model.type, name: model.name, reasoningEffort: effort });
	};

	return (
		<>
			<DropdownMenuSeparator />
			<div className="px-2 pb-2">
				<output className="block text-xs text-muted">
					<TextOverflowTooltip className="truncate">
						{formatReasoningEffort(reasoningEffort)}
					</TextOverflowTooltip>
				</output>
				<Slider
					className="mt-2"
					disabled={values.length < 2}
					// Radix positions the thumb by dividing by max - min, so a single value still needs a range.
					max={Math.max(values.length - 1, 1)}
					min={0}
					onKeyDown={keepKeysInsideSlider}
					onValueChange={handleValueChange}
					step={1}
					value={[values.indexOf(reasoningEffort)]}
				>
					<SliderTrack>
						<SliderRange />
					</SliderTrack>
					<SliderThumb />
				</Slider>
			</div>
		</>
	);
};

export { ChatReasoningEffortSlider };
